import React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { useStore } from '../../store/store';
import NavbarSelector from '../Layout/NavbarSelector';

// Style du tableau (configuration.tableStyles) choisi pour la box : dans le
// panel du tableau, et dans celui de sa configuration (cf. TableConfigDrawer).
// Sélection par id : deux styles peuvent porter le même nom (sections
// injectées plusieurs fois), choisir par nom appliquait toujours le premier.
const TableStyleSelect = ({ boxId }) => {
  const updateBox = useStore(({ updateBox }) => updateBox);
  const tableStyles = useStore(({ configuration }) => configuration.tableStyles);
  // Tableau du document ou d'un masque (en-tête, pied), comme updateBox.
  const tableStyleId = useStore(({ boxes, masks }) =>
    (boxes.find(({ id }) => id === boxId)
      ?? masks.flatMap((m) => m.boxes ?? []).find(({ id }) => id === boxId))
      ?.tableStyleId
  );
  return (
    <NavbarSelector
      suffixIcon={<CaretDownOutlined />}
      width="100%"
      onSelect={(styleId) => {
        updateBox(boxId, (box) => {
          box.tableStyleId = styleId;
        });
      }}
      selectedValue={tableStyleId}
      // Liste plus large que le champ (antd la décale si elle déborde de
      // l'écran) : les noms des styles venus d'une section y étaient coupés.
      popupMatchSelectWidth={false}
      dropdownStyle={{ width: 'min(480px, 90vw)' }}
      // `title` : nom complet au survol, la liste coupe les noms longs (styles
      // venus d'une section).
      options={tableStyles.map(style => ({ value: style.id, label: style.name, title: style.name }))}
    />
  );
};

export default TableStyleSelect;
